import React from 'react';
import './TopBar.css';
import farmIcon from '../assets/icons/farm.webp';
import ranchIcon from '../assets/icons/ranch.webp';
import toolIcon from '../assets/icons/tool.webp';
import rcoinIcon from '../assets/icons/rcoin.webp';
import staminaIcon from '../assets/icons/stamina.webp';
import bgWood from '../assets/bg/bg-wood.webp';
import downIcons from '../assets/icons/downIcons.webp';
import SEASONS from '../config/seasons';

export default function TopBar({ balances, stamina, onOpenEnergyModal, seasonId }) {
  if (!balances || !stamina) return null;

  const parseBalance = (symbol) => {
    const list = Array.isArray(balances) ? balances : Object.values(balances || {});
    const entry = list.find((b) => typeof b === 'string' && b.endsWith(` ${symbol}`));
    return entry ? parseFloat(entry.split(' ')[0]).toFixed(4) : '0.0000';
  };

  const items = [
    { icon: ranchIcon, label: parseBalance('RANCH') },
    { icon: farmIcon, label: parseBalance('FARM') },
    { icon: toolIcon, label: parseBalance('TOOL') },
    {
      icon: staminaIcon,
      label: `${stamina.first}/${stamina.second}`,
      isStamina: true,
    },
    { icon: rcoinIcon, label: parseBalance('RCOIN') },
  ];

  const currentSeason = SEASONS.find(s => s.id === seasonId);
  const emojis = {
    spring: '🌼',
    summer: '☀️',
    autumn: '🍂',
    winter: '❄️'
  };

  const nextProbabilities = (() => {
    if (!currentSeason) return [];
    const weights = currentSeason.weights;
    const total = Object.values(weights).reduce((sum, val) => sum + val, 0);
    return Object.entries(weights).map(([key, val]) => {
      const seasonData = SEASONS.find(s => s.session_name === key);
      return {
        name: key,
        label: seasonData?.session_name || key,
        icon: seasonData?.icon || '',
        color: seasonData?.color || '#ccc',
        emoji: emojis[key] || '',
        probability: ((val / total) * 100).toFixed(2),
        width: `${(val / total) * 100}%`
      };
    });
  })();

  return (
    <>
      <div className="top-bar">

        <div
          className="season-box"
          style={{ backgroundImage: `url(${bgWood})` }}
        >
          <span className="season-text">
            <span className="season-emoji-big">{emojis[currentSeason?.session_name]}</span>
            {currentSeason?.session_name?.charAt(0).toUpperCase() + currentSeason?.session_name?.slice(1)}
          </span>
        </div>

        <div className="resources-wrapper">
          {items.map((res, i) => (
            <div
              key={i}
              className="resource-box"
              style={{ backgroundImage: `url(${bgWood})` }}
            >
              <div className="icon-wrapper"><img src={res.icon} alt="" /></div>
              <span className="resource-text">{res.label}</span>
              {res.isStamina && (
                <>
                  <img src={downIcons} alt="plus" className="plus-button" onClick={onOpenEnergyModal} />
                  <div className="stamina-bar-container">
                    <div
                      className="stamina-bar-fill"
                      style={{ width: `${(stamina.first / stamina.second) * 100}%` }}
                    />
                  </div>
                </>
              )}
            </div>
          ))}
        </div>
      </div>

      <div className="season-probability-wrapper">
        <div className="season-probability-label">Next Season :</div>
        <div className="season-probability-bar">
          {nextProbabilities.map((p, i) => (
            <div
              key={i}
              className="season-probability-segment"
              style={{ width: p.width, backgroundColor: p.color }}
              title={`${p.label}: ${p.probability}%`}
            >
              <span className="season-probability-emoji">{p.emoji}</span>
              <span className="season-probability-text">{p.probability}%</span>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}
